import { render, staticRenderFns } from "./StockNews.vue?vue&type=template&id=6716b774&scoped=true&"
import script from "./StockNews.vue?vue&type=script&lang=js&"
export * from "./StockNews.vue?vue&type=script&lang=js&"
import style0 from "./StockNews.vue?vue&type=style&index=0&id=6716b774&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6716b774",
  null
  
)

export default component.exports